import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["navbar", "shared_with"]

  static values = {
    page: String,
    filter: String
  }

  connect() {
    if(this.hasNavbarTarget) {
      let navLink;
      if(this.filterValue == "shared") {
        navLink = this.navbarTarget.querySelector(`a[data-page="shared"]`);
      } else if(this.filterValue == "projects") {
        navLink = this.navbarTarget.querySelector(`a[data-page="projects"]`);
      } else {
        navLink = this.navbarTarget.querySelector(`a[data-page="personal"]`);
      }

      if(navLink) {
        navLink.classList.add("text-white")
      }
    }
  }

  animateCheckbox() {
    event.target.classList = []
    event.target.classList.add("svg-inline--fa", "fa-spinner", "fa-spin-pulse")
    event.target.setAttribute("icon", "spinner");
    event.target.parentNode.classList.add("ps-1")
  }

  toggleShareWith() {
    switch(event.target.value) {
      case "shared":
        this.shared_withTarget.classList.remove('d-none')
        break;
      default:
        this.shared_withTarget.classList.add('d-none')
    }
  }

  setDueDate() {
    let uuid = event.target.dataset.uuid;
    let html = `
      <div class="container">
        <div class="mb-3">
          <label for="task_duedate" class="form-label">${I18n.t('task.set_duedate')}</label>
          <input type="date" class="form-control" id="task_duedate" name="task[duedate]" value="${event.target.dataset.date}">
        </div>
      </div>
    `

    bootbox.dialog({
      message: html,
      size: "small",
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('cancel'),
          className: "btn-outline-secondary",
        },
        remove: {
          label: I18n.t('task.nodate'),
          className: "btn-outline-secondary",
          callback: function() {
            let date = document.querySelector("input#task_duedate").value
            Rails.ajax({
              url: `/${I18n.locale}/tasks/${uuid}/removedate`,
              type: "post",
              success: function(data) {
                bootbox.hideAll();
              },
              error: function(data) {}
            });

    	      bootbox.hideAll();
          }
        },
        delete: {
          label: I18n.t('btn.save'),
          className: "btn-success",
          callback: function() {
            let date = document.querySelector("input#task_duedate").value
            let url = '';
            if(date != '') {
              url = `/${I18n.locale}/tasks/${uuid}/setdate/${date}`;
          	} else {
              url = `/${I18n.locale}/tasks/${uuid}/setdate/${new Date().toJSON().slice(0, 10)}}`;
          	}
            Rails.ajax({
              url: url,
              type: "post",
              success: function(data) {
                bootbox.hideAll();
              },
              error: function(data) {}
            });
          }
        }
      }
    });
  }
}
